// ═══════════════════════════════════════════════════════════════════
//  modules/erp/EnderchestGrid.js
//  EnderchestGrid
// ═══════════════════════════════════════════════════════════════════

import { ItemIcon } from "./ItemIcon";
import { MC_LABEL, MC_PANEL } from "./styles";

// Grille enderchest 3×9 (slots 0-26)
export function EnderchestGrid({ items, canAct, onSlotClick }) {
  const getItem = (slot) => items.find((i) => i.slot === slot) || null;
  return (
    <div style={MC_PANEL}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={MC_LABEL}>COFFRE DE L'ENDER</div>
        {[0, 1, 2].map((row) => (
          <div key={row} style={{ display: "flex", gap: 6 }}>
            {Array.from({ length: 9 }, (_, col) => {
              const slot = row * 9 + col;
              const it = getItem(slot);
              return <ItemIcon key={slot} item={it}
                clickable={canAct && !!it} onClick={() => onSlotClick && onSlotClick("ENDER", slot, it)} />;
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
